export default __webpack_public_path__ + "static/media/request.2fb23b9e.svg";